import { AttributeDefinition, CompanyAdminMeta } from '@dispatch/shared/types';
import { AdminDashboardTable } from './AdminDashboardTable';
import { actionsColumn, clickToCopy, textColumn } from '@dispatch/web/ui';
import {
  GridActionsCellItem,
  GridColDef,
  GridRowParams,
} from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import React from 'react';
import { handleModalOpen, onClick } from './helpers';

export const AttributeAdmin = ({
  attributes = [],
  modalState,
  isLoading,
}: {
  attributes?: AttributeDefinition[];
  modalState?: {
    meta: CompanyAdminMeta;
    setmeta: React.Dispatch<CompanyAdminMeta>;
  };
  isLoading?: boolean;
}) => {
  const handleClick = React.useCallback(
    (params: GridRowParams) => onClick('addAttribute', params, modalState),
    [modalState?.meta.addAttribute]
  );

  const handleDelete = React.useCallback(
    (params: GridRowParams & { type?: string }) => {
      params.type = 'attributeDefinition';
      onClick('delete', params, modalState);
    },
    [modalState?.meta]
  );

  const columns: GridColDef[] = [
    clickToCopy({
      field: 'integrationGUID',
      headerName: 'ID',
      flex: 2,
    }),
    textColumn({
      field: 'displayName',
      headerName: 'Name',
      flex: 2,
    }),
    actionsColumn((params: GridRowParams) => [
      <GridActionsCellItem
        key="edit"
        icon={<EditIcon />}
        label="EDIT"
        onClick={() => {
          handleClick(params);
        }}
        showInMenu
      />,
      <GridActionsCellItem
        key="delete"
        icon={<DeleteIcon />}
        label="DELETE"
        onClick={() => {
          handleDelete(params);
        }}
        showInMenu
      />,
    ]),
  ];

  return (
    <AdminDashboardTable<AttributeDefinition>
      isLoading={isLoading}
      data={attributes}
      identifier="integrationGUID"
      columns={columns}
      type="attribute"
      handleClick={() => handleModalOpen('addAttribute', modalState)}
    />
  );
};
